"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanInformation = void 0;
const zod_1 = require("zod");
const enums_1 = require("../enums");
exports.LoanInformation = zod_1.z
    .object({
    originalLoanAmount: zod_1.z.number(),
    currentInterestPerY: zod_1.z.number(),
    currentRepaymentPerY: zod_1.z.number(),
    repaymentType: zod_1.z.enum(enums_1.RepaymentTypes),
    borrowedCapitalText: zod_1.z.string(),
    borrowedCapital: zod_1.z.boolean(),
    debtInEur: zod_1.z.number(),
    debtInEurDate: zod_1.z.coerce.date(),
    remainingLoanAmount: zod_1.z.number(),
})
    .partial();
//# sourceMappingURL=loanInformation.js.map